import { Injectable } from '@angular/core';

import { EntityStore, StoreConfig } from '@datorama/akita';

import { PartiesState } from './parties.state';

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'party', idKey: '_id' })
export class PartiesStore extends EntityStore<PartiesState> {
  constructor() {
    super();
  }
}
